import { render } from "./ConferenceCallDetails.vue?vue&type=template&id=067b0760"
import script from "./ConferenceCallDetails.vue?vue&type=script&lang=js"
export * from "./ConferenceCallDetails.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ConferenceCallDetails.vue?vue&type=style&index=0&id=067b0760&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__